import React from 'react';

/**
 * Loop-roll buttons with slip mode (like djay.app)
 * Hold button to activate temporary loop, release to return to real position
 * Sizes: 1/32, 1/16, 1/8, 1/4, 1/2, 1, 2, 4, 8, 16, 32 beats
 */
const LoopRollButtons = ({ activeSize, onLoopRollStart, onLoopRollEnd, disabled = false }) => {
  // Loop sizes with fractions
  const loopSizes = [
    { label: '1/32', value: 1/32 },
    { label: '1/16', value: 1/16 },
    { label: '1/8', value: 1/8 },
    { label: '1/4', value: 1/4 },
    { label: '1/2', value: 1/2 },
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '4', value: 4 },
    { label: '8', value: 8 },
    { label: '16', value: 16 },
    { label: '32', value: 32 }
  ];
  
  const handleMouseDown = (size) => {
    if (!disabled) {
      onLoopRollStart(size);
    }
  };
  
  const handleMouseUp = () => {
    if (!disabled) {
      onLoopRollEnd();
    }
  };
  
  const handleTouchStart = (e, size) => {
    e.preventDefault();
    if (!disabled) {
      onLoopRollStart(size);
    }
  };
  
  const handleTouchEnd = (e) => {
    e.preventDefault();
    if (!disabled) {
      onLoopRollEnd();
    }
  };
  
  return (
    <div className="space-y-1">
      <div className="flex flex-wrap gap-1">
        {loopSizes.map(({ label, value }) => {
          const isActive = activeSize === value;
          
          return (
            <button
              key={label}
              onMouseDown={() => handleMouseDown(value)}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseUp} // Release if mouse leaves
              onTouchStart={(e) => handleTouchStart(e, value)}
              onTouchEnd={handleTouchEnd}
              onTouchCancel={handleTouchEnd}
              disabled={disabled}
              className={`
                flex-shrink-0 px-2 h-7 sm:h-8 rounded-md text-[10px] sm:text-xs font-bold
                transition-all duration-150
                select-none
                ${isActive
                  ? 'bg-gradient-to-r from-purple-600 to-blue-600 text-white shadow-lg scale-105 border-2 border-purple-400 ring-2 ring-purple-400/30'
                  : 'bg-slate-800/70 text-slate-300 border border-slate-600/50 hover:bg-slate-700 hover:text-white hover:border-slate-500'
                }
                ${disabled ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer active:scale-95'}
              `}
              title={`Loop-roll ${label} temps (maintenir)`}
              style={{ touchAction: 'none' }} // Prevent scrolling on touch
            >
              {label}
            </button>
          );
        })}
      </div>
      <div className="text-[9px] sm:text-[10px] text-purple-300/50 italic">
        Maintenir = boucle temporaire (slip mode)
      </div>
    </div>
  );
};

export default LoopRollButtons;
